import { CanActivateFn, Router } from '@angular/router';
import { EventService } from '../services/event.service';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';

export const eventExistsGuard: CanActivateFn = (route, state) => {  
  const eventService = inject(EventService);
  const router = inject(Router);
  const eventName = route.params['eventname'];
  console.debug('eventExistsGuard for event:', eventName);
  return eventService.eventExists(eventName).pipe(
    map(exists => {
      if (!exists) {
        router.navigate(['/welcome']);
        console.debug('event does not exist, redirecting to welcome');
        return false;
      }
      console.debug('event exists, proceeding');
      return true;
    }),
    catchError(() => {
      console.debug('error checking event existence, redirecting to welcome');
      router.navigate(['/welcome']);
      return of(false);
    })
  );
  return true;
};
